import { create } from 'zustand'
import { ValidateRulesToAccessMeetStore } from './types'

export const validateRulesToAccessMeetStore =
  create<ValidateRulesToAccessMeetStore>(set => ({
    isAbleToAccessMeet: true,
    setIsAbleToAccessMeet: value => set(() => ({ isAbleToAccessMeet: value })),
  }))
